<template>
	<ul>
		<li :class="{ 'active' : Object.keys(selectedSite).length === 0  }">
			<a href="/" @click.prevent="setSelectedSite('4choice')">
				<img :src="defaultLogoUrl" alt="4Choice" title="4Choice">
			</a>
		</li>
		<li v-for="site in availableSites" :class="{ 'active' : selectedSite.name === site.name }">
			<a :href="'/' + site.slug" @click.prevent="setSelectedSite(site.slug)">
				<img :src="site.logo_url" :alt="site.name" :title="site.name">
			</a>
		</li>
	</ul>
</template>

<script>
	import Errors from '../Utils/Errors.js'

	export default {
		name: 'SiteSelector',
		props: {
			dataCurrentUrl: {
				type: String
			},
			dataDefaultLogoUrl: {
				type: String
			}
		},
		data() {
			return {
				currentUrl: this.dataCurrentUrl,
				defaultLogoUrl: this.dataDefaultLogoUrl,
				availableSites: this.$availableSites,
				selectedSite: this.$selectedSite,
				errors: new Errors(),
				urlToRedirect: ""
			}
		},
		methods: {
			findBaseUrl: function (str) {
				let delimiter = '/';
				let parts = str.split(delimiter).slice(0, 3);
				return parts.join(delimiter);
			},
			findSubPage: function (str) {
				let delimiter = '/';
				let parts = str.split(delimiter).slice(3);
				return parts.join(delimiter);
			},
			replaceLocation: function (str, newSlugToUse) {
				for (let site in this.availableSites) {
					return str.replace(str, this.findBaseUrl(str) + "/" + newSlugToUse);
				}
			},
			setSelectedSite: function (siteSlug) {
				let vm = this;
				if (siteSlug === "4choice") {
					vm.urlToRedirect = this.findBaseUrl(vm.dataCurrentUrl);
					window.location.assign(vm.urlToRedirect);
					return true;
				} else {
					vm.urlToRedirect = vm.replaceLocation(vm.dataCurrentUrl, siteSlug);
				}
				vm.errors.clear();
				axios.post('/api/changeSite', {site: siteSlug})
					.then(response => {
						window.location.assign(vm.urlToRedirect);
						return true;
					})
					.catch(e => {
						this.errors.record(e.response.data);
					});
			}
		}
	}
</script>

<style scoped>

</style>
